// if (localStorage.getItem('cookieSeen') != 'shown') {
  //      $('.gdpr').delay(2000).fadeIn();
  //      localStorage.setItem('cookieSeen','shown')
  //    };
  //    $('#gdpr_btn').on('click', function () {
  //      $(this).parents('.gdpr').fadeOut();
  // });
  
  var formBox = $("#inquiry_form");
  formBox.hide();
  
  var navTrigger = $("#nav_trigger_mobile");
  var mobileNav = $(".mobile_nav");
  mobileNav.removeClass("active");
  
  var inpSearch = $("#search_field_inp");
  inpSearch.removeClass("get__");
  
  //mobile menu
  $(document).ready(function () {
    $(".has-submenu .nav_link").each(function () {
      $(this).on("click", function (e) {
        // e.preventDefault();
        $(this).parent().siblings().children(".menuShow").removeClass("menuShow");
  
        $(this).siblings().toggleClass("menuShow");
        // console.log('click')
      });
    });
  
    navTrigger.on("click", function () {
      mobileNav.toggleClass("active");
    });
  
    var menuExpandA = $(".mobile_nav .nav_item .item_expand");
    var menuExpandB = $(".mobile_nav .nav_item .item_expand_child");
    var hideTheChildren = $(".mobile_nav .nav_item .sub_nav_col .list_child");
  
    hideTheChildren.each(function () {
      $(this).hide();
    });
  
    //sub menu
    var subNav = $(".mobile_nav .nav_item .sub_nav_col");
  
    menuExpandA.each(function () {
      $(this).on("click", function (e) {
        e.preventDefault();
        $(this).parent().siblings(".sub_nav_col").slideToggle();
        // $(this).children().toggleClass('fa-plus');
        $(this).toggleClass("minus");
        $(this)
          .parent()
          .siblings(".sub_nav_col")
          .each(function () {
            $(this).children(".list_child").hide();
          });
  
        console.log(" Iam being clicked");
        $(this)
          .parents(".nav_item.has_child")
          .siblings()
          .children(".sub_nav_col")
          .slideUp();
        $(this)
          .parents(".nav_item.has_child")
          .siblings()
          .find(".item_expand")
          .removeClass("minus");
        $(this)
          .parent()
          .siblings(".sub_nav_col")
          .find(".item_expand_child")
          .removeClass("minus");
      });
    });
  
    menuExpandB.each(function () {
      $(this).on("click", function (e) {
        e.preventDefault();
        $(this).toggleClass("minus");
        // $(this).parent().siblings('.list_child').slideToggle().toggleClass('active');
        // $(this).parents('.d-flex').next('.list_child').slideToggle().toggleClass('active');
  
        var nextTab = $(this).parents(".d-flex").next(".list_child");
        $(nextTab).slideToggle().toggleClass("active");
  
        $(".list_child").each(function () {
          if ($(this).attr("id") !== $(nextTab).attr("id")) {
            console.log($(this).attr("id"), $(nextTab).attr("id"));
            $(this).slideUp();
          }
        });
  
        //hide all the accordins
        var html = $(this).parents(".d-flex").next(".list_child").html();
        // console.log('html', html);
  
        // $(this).parents('.sub_nav_col').siblings().children('.list_child').slideUp().removeClass('active');
        //   $(this).parent('.d-flex').next('list_child').slideUp().removeClass('active');
        $(this)
          .parents(".sub_nav_col")
          .siblings()
          .find(".item_expand_child")
          .removeClass("minus");
      });
    });
  
    subNav.each(function () {
      $(this).hide();
      $(this).find();
    });
  });
  
  $(document).ready(function () {
    //photo zoom
    var $zoom = $(".zoom").magnify();
  
    //crousel for exclusive items for you
    $(".exclusives-carousel").owlCarousel({
        loop: true,
        margin: 30,
        nav: true,
       navText: [
        "<img src='//nepalirudraksha.com/cdn/shop/t/2/assets/right-arrow.svg?v=100995345355816366901636698439'>",
        "<img src='//nepalirudraksha.com/cdn/shop/t/2/assets/right-arrow.svg?v=100995345355816366901636698439'>",
      ],
  
        dots: false,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 3,
            },
            1000: {
                items: 4,
            },
        },
    });
  
    //crousel for exclusive items for you
    $(".interested").owlCarousel({
      loop: true,
      margin: 30,
      nav: true,
      navText: [
        "<img src='./dist/images/right-arrow.svg'>",
        "<img src='./dist/images/right-arrow.svg'>",
      ],
      dots: false,
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 3,
        },
        1000: {
          items: 4,
        },
      },
    });
  
    //testimonial crousel
    $(".testimonial_carousel").owlCarousel({
      loop: true,
      margin: 30,
      nav: true,
      navText: [
        "<img src='//nepalirudraksha.com/cdn/shop/t/2/assets/right-arrow.svg?v=100995345355816366901636698439'>",
        "<img src='//nepalirudraksha.com/cdn/shop/t/2/assets/right-arrow.svg?v=100995345355816366901636698439'>",
      ],
      dots: false,
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 3,
        },
        1000: {
          items: 3,
        },
      },
    });
  
    //hero carousel
    $(".hero_carousel").owlCarousel({
      loop: true,
      margin: 0,
      nav: true,
      autoplay: false,
      navText: [
        "<img src='//nepalirudraksha.com/cdn/shop/t/2/assets/right-arrow.svg?v=100995345355816366901636698439'>",
        "<img src='//nepalirudraksha.com/cdn/shop/t/2/assets/right-arrow.svg?v=100995345355816366901636698439'>",
      ],
      // navText: [
      //     "<img src= '" +
      //     neparudraksha.theme_url +
      //     "/dist/images/right-arrow.svg'>",
      //     "<img src='" + neparudraksha.theme_url + "/dist/images/right-arrow.svg'>",
      // ],
  
      autoplayHoverPause: true,
      autoplayTimeout: 8000,
      dots: true,
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 1,
        },
        1000: {
          items: 1,
        },
      },
    });
  
    //hero carousel
    $(".shop_category_carousel").removeClass("owl-carousel");
    $(".shop_category_carousel").removeClass("owl-theme");
  
    if ($(window).innerWidth() > 767) {
      $(".shop_category_carousel").addClass("owl-carousel");
      $(".shop_category_carousel").addClass("owl-theme");
      $(".shop_category_carousel").owlCarousel({
        loop: true,
        margin: 30,
        nav: true,
        navText: [
          "<img src='//nepalirudraksha.com/cdn/shop/t/2/assets/right-arrow.svg?v=100995345355816366901636698439'>",
          "<img src='//nepalirudraksha.com/cdn/shop/t/2/assets/right-arrow.svg?v=100995345355816366901636698439'>",
        ],
        dots: false,
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 1,
          },
          1000: {
            items: 6,
          },
        },
      });
    }
  
    function displayVals() {
      var singleValues = $(".numbers_select").val();
  
      if (singleValues == 1) {
        console.log("nepali numnber");
        $(this).siblings("img").attr("src", "dist/icons/nepal.svg");
      } else if (singleValues == 2) {
        console.log("American number");
        $(this).siblings("img").attr("src", "dist/icons/united-states.svg");
      }
    }
  
    $("select").change(displayVals);
    displayVals();
  
    //product single page carousel
    $(document).ready(function () {
      var sync1 = $("#sync1");
      var sync2 = $("#sync2");
      var slidesPerPage = 5; //globaly define number of elements per page
      var syncedSecondary = true;
  
      sync1
        .owlCarousel({
          items: 1,
          autoplay: false,
          dots: false,
          loop: true,
          onTranslated: function () {
            // Update Magnify when slide changes
            $zoom.destroy().magnify();
          },
          //   responsiveRefreshRate : 200,
          navText: [
            '<svg width="100%" height="100%" viewBox="0 0 11 20"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M9.554,1.001l-8.607,8.607l8.607,8.606"/></svg>',
            '<svg width="100%" height="100%" viewBox="0 0 11 20" version="1.1"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M1.054,18.214l8.606,-8.606l-8.606,-8.607"/></svg>',
          ],
        })
        .on("changed.owl.carousel", syncPosition);
  
      sync2
        .on("initialized.owl.carousel", function () {
          sync2.find(".owl-item").eq(0).addClass("current");
        })
        .owlCarousel({
          items: slidesPerPage,
          //   dots: true,
          //   nav: true,
          //   smartSpeed: 200,
          //   slideSpeed : 500,
          margin: 5,
          slideBy: slidesPerPage, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
          responsiveRefreshRate: 100,
        })
        .on("changed.owl.carousel", syncPosition2);
  
      function syncPosition(el) {
        //if you set loop to false, you have to restore this next line
        //var current = el.item.index;
  
        //if you disable loop you have to comment this block
        var count = el.item.count - 1;
        var current = Math.round(el.item.index - el.item.count / 2 - 0.5);
  
        if (current < 0) {
          current = count;
        }
        if (current > count) {
          current = 0;
        }
  
        //end block
  
        sync2
          .find(".owl-item")
          .removeClass("current")
          .eq(current)
          .addClass("current");
        var onscreen = sync2.find(".owl-item.active").length - 1;
        var start = sync2.find(".owl-item.active").first().index();
        var end = sync2.find(".owl-item.active").last().index();
  
        if (current > end) {
          sync2.data("owl.carousel").to(current, 100, true);
        }
        if (current < start) {
          sync2.data("owl.carousel").to(current - onscreen, 100, true);
        }
      }
  
      function syncPosition2(el) {
        if (syncedSecondary) {
          var number = el.item.index;
          sync1.data("owl.carousel").to(number, 100, true);
        }
      }
  
      sync2.on("click", ".owl-item", function (e) {
        e.preventDefault();
        var number = $(this).index();
        sync1.data("owl.carousel").to(number, 300, true);
      });
    });
  
    //wishlist button
    $(function () {
      $(".wishlist_button div i").click(function () {
        $("i,span").toggleClass("press", 1000);
      });
    });
  
    //item select options -- product single
    var selectStyle = $(".single_selector");
  
    selectStyle.each(function () {
      $(this).on("click", function () {
        $(this).addClass("active");
        $(this).siblings().removeClass("active");
      });
    });
  
    //product-single inquiry form
    var closeInquiry = $("#inquiry_close");
    var sendInquiry = $("#send_inquiry");
  
    sendInquiry.on("click", function () {
      formBox.fadeIn();
    });
  
    closeInquiry.on("click", function () {
      formBox.fadeOut();
    });
  
    if (formBox.length) {
      $(document).keydown(function (event) {
        if (event.keyCode == 27) {
          console.log("escape pressed");
          formBox.fadeOut();
        }
      });
    }
  });
  
  // menu search
  $(document).ready(function () {
    var btnSearch = $("#search_button_trigger");
  
    inpSearch.removeClass("get__");
  
    btnSearch.on("click", function (e) {
      e.preventDefault();
      inpSearch.addClass("get__");
      inpSearch.children(".search_field_inp_child").focus();
      $(this).siblings(".search_field").children("input").select();
  
      if (inpSearch.hasClass("get__")) {
        console.log("it has class this");
        // $(document).on('click', function() {
        // inpSearch.removeClass('get__');
        // });
  
        $(document).keyup(function (e) {
          if (e.keyCode == 27) {
            inpSearch.removeClass("get__");
          }
        });
      }
    });
  
    $("#closeInp").on("click", function (e) {
      e.preventDefault();
      $(this).parent().removeClass("get__");
    });
  });
  
  //menu height adjust
  $(document).ready(function () {
    var getHeaderHeight = $(".header1").height();
    var setHeight = $(".top_bar_height_adjust");
    console.log(getHeaderHeight);
    if ($(window).width() < 767) {
      console.log("height increased");
      setHeight.css("margin-top", getHeaderHeight);
    }
  });
  
  // function setCookie(name, value, daysToLive) {
  //      // Encode value in order to escape semicolons, commas, and whitespace
  //      var cookie = name + "=" + encodeURIComponent(value);
  
  //      cookie +=";path=/";
  
  //      if(typeof daysToLive === "number") {
  //          /* Sets the max-age attribute so that the cookie expires
  //          after the specified number of days */
  //          cookie += "; max-age=" + (daysToLive*24*60*60);
  
  //          document.cookie = cookie;
  //      }
  
  //      console.log("Cookie", cookie);
  //  }
  
  //  function getCookie(name) {
  //      // Split cookie string and get all individual name=value pairs in an array
  //      var cookieArr = document.cookie.split(";");
  
  //      // Loop through the array elements
  //      for(var i = 0; i < cookieArr.length; i++) {
  //          var cookiePair = cookieArr[i].split("=");
  
  //          /* Removing whitespace at the beginning of the cookie name
  //          and compare it with the given string */
  //          if(name == cookiePair[0].trim()) {
  //              // Decode the cookie value and return
  //              return decodeURIComponent(cookiePair[1]);
  //          }
  //      }
  
  //      // Return null if not found
  //      return null;
  //  }
  
  //catergory tags
  $(document).ready(function () {
    $(".cat_tag").each(function () {
      $(this).parent("fiigure").css("position", "relative");
    });
  
    if ($(window).width() < 768) {
      $(".chat_btn__ br").remove();
      $(".chat_btn__").css("display", "inline");
    }
  
    $("#currency-changer").on("change", function (el) {
      var currency_code = $(this).val();
  
      // localStorage.setItem('currency', currency_code);
  
      // setCookie('currency', currency_code, 30);
  
      Cookies.remove("currency");
      Cookies.remove("nr_currency");
      Cookies.set("nr_currency", currency_code, { expires: 1, path: "/" });
      var multiplier = $("option:selected", this).attr("data-value");
  
      // console.log('multiplier', multiplier);
  
      $(".price").each(function () {
        var price = $(this).attr("data-price");
  
        // console.log(price, multiplier);
  
        var new_price = price * multiplier;
  
        $(this).html(currency_code + " " + new_price.toFixed(2));
      });
      // console.log(currency_code);
    });
  
    $("#currency-changer").change();
    $("#currency-changer-top").on("change", function (el) {
      $("#currency-changer").change();
    });
    $(".tab-outer a").on("click", function (e) {
      e.preventDefault();
      var $this = this;
      tabId = $(this).attr("href").split("#")[1];
      if ($(this).hasClass("active")) {
        setTimeout(function () {
          $("#" + tabId).attr("class", "tab-pane fade");
          $("#" + tabId).removeClass("show");
          $($this).attr("class", "nav-link active_not_needed");
        }, 10);
      } else {
        $(this).tab("show");
      }
    });
  });
  
  //checkout
  
  // $(document).ready(function() {
  //      var formSelect = $('.checkout_form');
  //      $('.checkout_form button.btn_next').on('click', function(){
  //           $(this).parents('.checkout_form').hide();
  //           $(this).parents('.checkout_form').next().fadeIn();
  //           $('body').scrollTop(0);
  //      });
  // });
  
  // $(document).ready(function() {
  //      var formSelect = $('.checkout_form');
  //      $('.checkout_form button.btn_next').on('click', function(e){
  //           e.preventDefault();
  //           console.log('next button is clicked');
  //           var present = $(this).parents('.box-form-outer').hide();
  //           var next = $(this).parents('.box-form-outer').next().fadeIn();
  //           // next.scrollTop(offset().top);
  //           $("body").scrollTop(0);
  //      });
  
  //      $('.pay_form').hide();
  
  //      $("#check").on('change', function(e){
  //           e.preventDefault();
  //           console.log('checked_billing');
  //           $('.pay_form').toggle();
  //      })
  // });
  
  $(window).on("load", function () {
    $(".se-pre-con1").fadeOut("slow");
  });
  
  jQuery(document).ready(function ($) {
    function getFBShares(page) {
      var shares;
      $.getJSON("http://graph.facebook.com/?ids=" + page, function (data) {
        if (data[page].shares > 1) {
          shares = data[page].shares;
          $("#fb-share").append(" (" + shares + ")");
        }
      });
    }
  
    function getTweets(page) {
      var tweets;
      $.getJSON(
        "http://urls.api.twitter.com/1/urls/count.json?url=" +
          page +
          "&callback=?",
        function (data) {
          if (data.count > 1) {
            tweets = data.count;
            $("#tweet").append(" (" + tweets + ")");
          }
        }
      );
    }
  
    function getLinkedIn(page) {
      var linkedinCount;
      $.getJSON(
        "http://www.linkedin.com/countserv/count/share?url=" +
          page +
          "&callback=?",
        function (data) {
          if (data.count > 1) {
            linkedinCount = data.count;
            $("#linkedin").append(" (" + linkedinCount + ")");
          }
        }
      );
    }
  
    var Url = window.location.href;
    var UrlEncoded = encodeURIComponent(Url);
    var title = encodeURIComponent(document.title);
    // getFBShares(Url);
    // getTweets(Url);
    // getLinkedIn(Url);
    //document.getElementById("email-share").href =
     // "mailto:?subject=Contacting from Email Us&to=contact@nepalirudraksha.com";
    //document.getElementById("whatsapp-chat-usa").href =
     // "https://wa.me/18722161719";
    //document.getElementById("whatsapp-chat-nepal").href =
    //  "https://wa.me/9779801059764";
    // document.getElementById("share-phone").href = "tel:+1(872)-216-1719";
  
    // document.getElementById("linkedin").href="http://www.linkedin.com/shareArticle?mini=true&url=" + UrlEncoded + "&title=" + title;
  
    // document.getElementById("gplus-share").href="https://plus.google.com/share?url=" + UrlEncoded;
  });
  
  //remove item from cart
  $(document).ready(function () {
    var btnRemoveItem = $(".btn_remove_order");
  
    btnRemoveItem.each(function () {
      $(this).on("click", function () {
        $(this).parents(".cart-table tr").remove();
      });
    });
  });